import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'

export const Section = styled.div`
  padding: 32px 0px;
  background-color: ${(props) => props.theme.lavenderMedium};
  #today {
    width: 144px;
  }
  #cnet {
    width: 101px;
  }
  #wirecutter {
    width: 125px;
  }
  #verge {
    width: 108px;
  }
  #gma {
    width: 66px;
  }
  @media (max-width: ${breakpoints.s}px) {
    #today {
      width: 120px;
    }
    #cnet {
      width: 84px;
    }
    #wirecutter {
      width: 125px;
    }
    #verge {
      width: 108px;
    }
    #gma {
      width: 76px;
    }
  }
`
export const ImageContainer = styled.div``
export const Header = styled.p`
  font-size: 12px;
  line-height: 18px;
  text-align: left;
  font-family: 'MatterBold';
  letter-spacing: 1px;
  @media (max-width: ${breakpoints.m}px) {
    width: 100%;
    text-align: center;
    margin: 0px;
    font-size: 12px;
    line-height: 18px;
  }
`
export const Container = styled.div`
  width: 90%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 40px;
  @media (max-width: ${breakpoints.xl}px) {
    width: 70%;
    gap: 24px 40px;
  }
  @media (max-width: ${breakpoints.l}px) {
    width: 90%;
  }
  @media (max-width: ${breakpoints.l}px) {
    gap: 24px;
  }
`
